import {Pipe, PipeTransform} from '@angular/core';
// tslint:disable-next-line:quotemark
import {BaseModel} from '../models/base.model';

@Pipe({
  name: 'lbaObjectsFilterPipe',
})

export class ObjectsFilterPipe implements PipeTransform {

  transform(objects: Array<BaseModel>, searchStr: string): any {
    searchStr = searchStr.toString().toLowerCase();
    const filteredObjects: Array<BaseModel> = [];
    if (searchStr.length === 0) {
      return objects;
    }
    for (const object of objects) {
      if (
        object.name.toLowerCase().indexOf(searchStr) !== -1 ||
        object.id.toString().indexOf(searchStr) !== -1
      ) {
        filteredObjects.push(object);
      }
    }
    return filteredObjects;
  }

}
